module.exports = {
    "breadcrumbs": `Lingiread`
};


//# sourceMappingURL=et-EE.main.js.map
